import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  //base: '/test',
  routes: [
    {
      path: '/',
      component: () => import('@/components/index'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/components/indexChild/home')
        },
        {
          path: '/productList',
          name: 'productList',
          component: () => import('@/components/indexChild/productList')
        },
        {
          path: '/serviceList',
          name: 'serviceList',
          component: () => import('@/components/indexChild/serviceList')
        },
        {
          path: '/details',
          name: 'details',
          component: () => import('@/components/indexChild/details')
        },
        {
          path: '/personal',
          component: () => import('@/components/indexChild/personal'),
          children: [
            {
              path: '',
              name: 'personalDef',
              meta: { requireAuth: true },
              component: () => import('@/components/indexChild/personalChild/account')
            },
            {
              path: '/personal/account',
              name: 'account',
              meta: { requireAuth: true },
              component: () => import('@/components/indexChild/personalChild/account')
            },
            {
              path: '/personal/userInfo',
              name: 'userInfo',
              meta: { requireAuth: true },
              component: () => import('@/components/indexChild/personalChild/userInfo')
            },
            {
              path: '/personal/orderDetail',
              name: 'orderDetail',
              meta: { requireAuth: true, employer: true },
              component: () => import('@/components/indexChild/personalChild/orderDetail')
            },
            {
              path: '/personal/myAssess',
              name: 'assess',
              meta: { requireAuth: true, employer: true },
              component: () => import('@/components/indexChild/personalChild/myAssess')
            },
            {
              path: '/personal/myEmploy',
              name: 'myEmploy',
              meta: { requireAuth: true, employer: true },
              component: () => import('@/components/indexChild/personalChild/myEmploy')
            },
            {
              path: '/personal/myCollect',
              name: 'myCollect',
              meta: { requireAuth: true },
              component: () => import('@/components/indexChild/personalChild/myCollect')
            },
            {
              path: '/personal/myMessage',
              name: 'myMessage',
              meta: { requireAuth: true },
              component: () => import('@/components/indexChild/personalChild/myMessage')
            },
            {
              path: '/personal/myRefund',
              name: 'myRefund',
              meta: { requireAuth: true, employer: true },
              component: () => import('@/components/indexChild/personalChild/myRefund')
            },
            {
              path: '/personal/myComplaint',
              name: 'myComplaint',
              meta: { requireAuth: true },
              component: () => import('@/components/indexChild/personalChild/myComplaint')
            },
            {
              path: '/personal/myService',
              name: 'myService',
              meta: { requireAuth: true, employee: true },
              component: () => import('@/components/managementChild/myHome')
            },
            {
              path: '/personal/workList',
              name: 'workList',
              meta: { requireAuth: true, employee: true },
              component: () => import('@/components/managementChild/workList')
            },
            {
              path: '/personal/editService',
              name: 'editService',
              meta: { requireAuth: true, employee: true },
              component: () => import('@/components/managementChild/editService')
            },
            {
              path: '/personal/myTask',
              name: 'myTask',
              meta: { requireAuth: true, employee: true },
              component: () => import('@/components/managementChild/myTask')
            },
            {
              path: '/personal/myAssess2',
              name: 'myAssess2',
              meta: { requireAuth: true, employee: true },
              component: () => import('@/components/managementChild/myAssess')
            },
            {
              path: '/personal/myIntegral',
              name: 'myIntegral',
              meta: { requireAuth: true, employee: true },
              component: () => import('@/components/managementChild/myIntegral')
            },
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/login')
    },
    {
      path: '/selectRegister',
      name: 'selectRegister',
      component: () => import('@/components/selectRegister')
    },
    {
      path: '/registered',
      name: 'registered',
      component: () => import('@/components/registered')
    },
    {
      path: '/registeredServant',
      name: 'registeredServant',
      component: () => import('@/components/registeredServant')
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: () => import('@/components/resetPassword')
    },
    {
      path: '/verifyEmail',
      name: 'verifyEmail',
      component: () => import('@/components/verifyEmail')
    },
    {
      path: '/temp',
      name: 'temp',
      component: () => import('@/components/temp')
    },
    {
      path: '/wen',
      name: 'myConnector',
      component: () => import('@/components/myConnector')
    },
    {
      path: '*',
      name: 'notFount',
      component: () => import('@/components/notFount')
    }
  ],
  //跳转时 滚动条事件
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});
router.beforeEach((to, from, next) => {
  var token = store.state.token ? store.state.token : $.cookie('LYPT_token');
  var isServicer = store.state.userInfo.isServicer ? store.state.userInfo.isServicer : $.cookie('LYPT_isServicer');
  if (to.meta.requireAuth) {
    //判断token是否存在
    if (token) {
      if (to.meta.employer && isServicer != 1) {
        next({ path: '/' });
      } else if (to.meta.employee && isServicer != 2) {
        next({ path: '/' });
      } else {
        next();
      }
    } else {
      //未登录
      next({
        path: '/',
        query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js